var render = function render(){var _vm=this,_c=_vm._self._c;return _c('x-err-dialog',{staticClass:"crm-activity-wrap",attrs:{"visible":_vm.visible}},[_c('div',{staticClass:"bg-wrap"},[_c('img',{attrs:{"src":_vm.img,"alt":""}}),_c('span',{staticClass:"close-area",on:{"click":_vm.close}})]),_c('img',{staticClass:"close-btn",attrs:{"src":require("./imgs/close_btn.png"),"alt":""},on:{"click":_vm.normalClose}})])
}
var staticRenderFns = []

export { render, staticRenderFns }